import PricingLayout from "@/components/PricingLayout";
import { ROUTE_SEO } from "@/config/seoData";
import { STANDARD_PACKAGES, STANDARD_MATRIX } from "@/config/pricingData";

const SeoPricing = () => (
  <PricingLayout
    testid="seo-pricing"
    seo={ROUTE_SEO.seoPricing}
    eyebrow="SEO Pricing"
    title="SEO packages built for measurable growth"
    intro="Four transparent packages covering keyword research, on-page and technical SEO, content optimisation, off-page authority and local search. Every engagement is scoped to your goals — request a quote and we'll recommend the right fit."
    packages={STANDARD_PACKAGES}
    matrix={STANDARD_MATRIX}
    crossLink={{
      prompt: "Looking for an enterprise-grade program with international, ecommerce and AI-era visibility?",
      href: "/elite-seo-packages/",
      label: "Explore Elite SEO Packages",
    }}
  />
);

export default SeoPricing;
